import { render, staticRenderFns } from "./customerReviews.vue?vue&type=template&id=a064f046&scoped=true"
import script from "./customerReviews.vue?vue&type=script&lang=js"
export * from "./customerReviews.vue?vue&type=script&lang=js"
import style0 from "./customerReviews.vue?vue&type=style&index=0&id=a064f046&prod&lang=scss&scoped=true"
import style1 from "./customerReviews.vue?vue&type=style&index=1&id=a064f046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a064f046",
  null
  
)

export default component.exports